module.exports = __webpack_public_path__ + "static/media/homeSkeletonXs.3d0013ea.svg";